/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserNoteGet = {
  readonly id?: number;
  /**
   * Attio valuation ID (UUID format)
   */
  attio_valuation_id?: string | null;
  /**
   * Fulfillment this note is associated with
   */
  fulfillment?: number | null;
  /**
   * Reference type: 'at' for Attio valuations, 'fu' for Fulfillments
   */
  reference_type?: UserNoteGet.reference_type;
  /**
   * Analyst note content (plain text only)
   */
  content?: string;
  readonly author?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace UserNoteGet {
  /**
   * Reference type: 'at' for Attio valuations, 'fu' for Fulfillments
   */
  export enum reference_type {
    AT = 'at',
    FU = 'fu',
  }
}

